
import { defineComponent, SetupContext } from "vue";
import { FoodRecommendationListItem } from "@/types/home";
import { PANTRY_FOOD_TYPE } from "@/types/pantry";
import { computed } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  components: { },
  name: "RecommendFoodItem",
  props: {
    data: {
      type: FoodRecommendationListItem,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const getImage = () => {
      return props.data && props.data.image ? props.data.image : "";
    };
    const getName = () => {
      return props.data ? props.data.name : "";
    };
    const isShow = () => {
      return props.data && (props.data.pantryId || props.data.pantryPlateId || props.data.pantryFridgeId || props.data.foodId);
    };
    const styleRoot = computed(() => {
      const visibility = isShow() ? "visible" : "hidden";
      return { 'visibility': visibility };
    });
    const clickFood = () => {
      const show = isShow();
      if (props.data == null) {
        return;
      }
      if (!show) {
        return;
      }
      let id = "";
      let type = "";
      const foodId = "" + props.data.foodId;
      if (props.data.pantryId != null) {
        id = "" + props.data.pantryId;
        type = PANTRY_FOOD_TYPE.USER;
      } else if (props.data.pantryPlateId != null) {
        id = "" + props.data.pantryPlateId;
        type = PANTRY_FOOD_TYPE.PLATE;
      } else if (props.data.pantryFridgeId != null) {
        id = "" + props.data.pantryFridgeId;
        type = PANTRY_FOOD_TYPE.FRIDGE;
      }
      NativeClient.sendDebugLog(
        "RecommendFoodItem selectFood id=" + id + " type=" + type + " foodId=" + foodId
      );
      context.emit("select-food", id, type, foodId);
    };
    const isPantryFood = () => {
      return props.data && (props.data.pantryId || props.data.pantryPlateId || props.data.pantryFridgeId);
    };
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("RecommendFoodItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("RecommendFoodItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    return {
      getImage,
      getName,
      styleRoot,
      clickFood,
      isPantryFood,
      onImageError
    };
  }
});
